var map = {
	"./DataCollectRouter.js": 787,
	"./DataGasStationRouter.js": 789,
	"./DataMachRouter.js": 786,
	"./DataMarketRouter.js": 790,
	"./LabelProcessRouter.js": 791,
	"./SmartOperationRouter.js": 788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 640;